<div class="login-content">
  <div class="block-left">
    <img class="logo" src="../../../assets/logo.png" />
    <div class="carousel-container">
      <div class="carousel-images">
        <img
          *ngFor="let image of images; let i = index"
          [src]="image"
          [class.active]="i === currentImageIndex"
          alt="Carousel Image"
        />
      </div>
    </div>
    <div class="carousel-dots">
      <span
        *ngFor="let image of images; let i = index"
        [class.active]="i === currentImageIndex"
        (click)="setImage(i)"
      ></span>
    </div>
  </div>

  @if (isLogin) {
    <div class="block-right">
      <form
        [formGroup]="loginForm"
        (ngSubmit)="submitLoginForm()"
        class="login-form"
      >
        <img class="logo" src="../../../assets/logo.png" />
        <h2>Entrar</h2>
        <div class="form-group" [ngClass]="{ focused: usernameFocused }">
          <label for="username" class="form-label">Usuário</label>
          <img
            [src]="
              usernameFocused
                ? '../../../assets/user-red.png'
                : '../../../assets/user-icon.png'
            "
            class="input-icon"
          />
          <input
            formControlName="username"
            type="text"
            name="username"
            class="form-input"
            placeholder="Usuário"
            (focus)="onFocus('username')"
            (blur)="onBlur('username')"
          />
        </div>
        <div class="form-group" [ngClass]="{ focused: passwordFocused }">
          <label for="password" class="form-label">Senha</label>
          <img
            [src]="
              passwordFocused
                ? '../../../assets/padlock-red.png'
                : '../../../assets/padlock-icon.png'
            "
            class="input-icon"
          />
          <input
            formControlName="password"
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            class="form-input"
            placeholder="Senha"
            (focus)="onFocus('password')"
          />
          <img
            *ngIf="passwordFocused"
            [src]="
              showPassword
                ? '../../../assets/olho_nao_exibi.png'
                : '../../../assets/olho_exibi.png'
            "
            class="toggle-password-icon"
            (click)="toggleShowPassword()"
          />
        </div>
        <a class="forgot-password" (click)="handleForgetPassword()"
          >Esqueci minha senha</a
        >

        @if(incorrectPassword){
        <div class="warning">
          <i class="material-icons v-align"> report_problem </i>
          <p>Usuário ou senha incorretos</p>
        </div>
        }

        <button type="submit" class="submit-button">Entrar</button>
      </form>
    </div>
  }

  @if (isForgotPassword) {
    <div class="block-right">
      <form class="forgot-password-form" [formGroup]="resetPasswordForm">
        <img class="logo" src="../../../assets/logo.png" />
        <div class="block-title">
          <h2>Esqueci minha senha</h2>
        </div>
        <p>
          Informe seu e-mail de cadastro para enviarmos o código de redefinição de
          senha
        </p>
        <div class="form-group">
          <label for="email" class="form-label">E-mail</label>
          <img src="../../../assets/email-icon.png" class="input-icon" />
          <input
            type="email"
            name="email"
            class="form-input"
            placeholder="Digite seu e-mail"
            formControlName="email"
          />
        </div>
        @if (resetPasswordForm.get('email')?.touched && resetPasswordForm.get('email')?.invalid) {
          <div class="warning">
            <i class="material-icons v-align"> report_problem </i>
            <p>E-mail Inválido!</p>
          </div>
        }

        <button type="submit" class="submit-button" (click)="handleClickResetPassword()">
          Enviar
        </button>
        <button
          type="button"
          class="cancel-button"
          (click)="handleInitialLoginPage()"
        >
          Voltar
        </button>
      </form>
    </div>
  }

  @if (isChangePassword) {
    <div class="block-right">
      <form class="login-form" style="gap: 12px" [formGroup]="changePasswordForm">
        <img class="logo" src="../../../assets/logo.png" />
        <p>Informe a nova senha</p>
        <div class="form-group" [ngClass]="{ focused: passwordFocused }">
          <label for="password" class="form-label">Nova senha:</label>
          <img [src]="passwordFocused ? '../../../assets/padlock-red.png' : '../../../assets/padlock-icon.png'" class="input-icon"/>
          <input
            formControlName="newPassword"
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            class="form-input"
            placeholder="Nova senha"
            (focus)="onFocus('password')"
          />
          <img *ngIf="passwordFocused" [src]=" showPassword ? '../../../assets/olho_nao_exibi.png' : '../../../assets/olho_exibi.png'" class="toggle-password-icon" (click)="toggleShowPassword()"/>
        </div>
        <div class="form-group" [ngClass]="{ focused: passwordFocused }">
          <label for="password" class="form-label">Confirme a nova senha:</label>
          <img [src]="passwordFocused ? '../../../assets/padlock-red.png' : '../../../assets/padlock-icon.png'" class="input-icon"/>
          <input
            formControlName="confirmNewPassword"
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            class="form-input"
            placeholder="Confirme a nova senha"
            (focus)="onFocus('password')"
          />
          <img *ngIf="passwordFocused" [src]="showPassword ? '../../../assets/olho_nao_exibi.png': '../../../assets/olho_exibi.png'"class="toggle-password-icon" (click)="toggleShowPassword()"/>
        </div>
        @if (changePasswordForm.get('newPassword')?.touched && !changePasswordForm.get('newPassword')?.value && !changePasswordForm.get('confirmNewPassword')?.value && changePasswordForm.get('confirmNewPassword')?.touched) {
          <div class="warning">
            <i class="material-icons v-align"> report_problem </i>
            <p> É necessário preencher todos os campos.</p>
          </div>
        }
        @if (changePasswordForm.errors?.['passwordsMismatch']) {
          <div class="warning">
            <i class="material-icons v-align"> report_problem </i>
            <p> As senhas não coincidem.</p>
          </div>
        }
        @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.errors?.['passwordStrength']) {
          <div class="warning">
            <i class="material-icons v-align"> report_problem </i>
            <p>A senha deve ter pelo menos 8 caracteres, incluindo 1 maiúscula, 1
              número e 1 caractere especial.</p>
          </div>
        }
        <button class="submit-button" type="submit" (click)="handleSubmitChangePassword()">
          Enviar
        </button>
        <button
          type="button"
          class="cancel-button"
          (click)="handleInitialLoginPage()"
        >
          Voltar
        </button>
      </form>
    </div>
  }
</div>
